"use strict";

import { Box, LoadingBox, useBoxStyles } from '@autoguru/overdrive';
import clsx from 'clsx';
import * as styles from './ExpandSideNavUserAvatarLoading.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExpandSideNavUserAvatarLoading = () => /*#__PURE__*/_jsx(Box, {
  "aria-disabled": "true",
  display: "flex",
  alignItems: "flexEnd",
  justifyContent: "flexStart",
  flexShrink: 0,
  children: /*#__PURE__*/_jsx(LoadingBox, {
    randomWidth: false,
    className: clsx(styles.avatarLoading, useBoxStyles({
      flexShrink: 0,
      borderRadius: 'full'
    }))
  })
});